// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorCard-cls1_LSI","cls2":"AuthorCard-cls2_WSn AuthorCard-cls1_LSI"};